// extracted by mini-css-extract-plugin
export default {"other":"Other_other__rX-zn","other--mobile":"Other_other--mobile__Gs-LK"};